const stats = [
  { value: '每日更新', label: '内容节奏' },
  { value: '全面覆盖', label: '内容范围' },
  { value: '安全访问', label: '服务保障' },
];

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20dramatic%20cinematic%20backdrop%20with%20soft%20spotlight%20rays%2C%20abstract%20warm%20amber%20and%20deep%20crimson%20gradients%2C%20theatrical%20stage%20atmosphere%20with%20subtle%20lens%20flares%2C%20mysterious%20elegant%20ambiance%2C%20premium%20entertainment%20industry%20aesthetic%2C%20no%20text%2C%20no%20people%2C%20cinematic%20composition%20with%20rich%20contrast%20and%20depth&width=1600&height=900&seq=hero-bg-91hlw&orientation=landscape"
          alt="91黑料网背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/45 to-black/65" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="w-full flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-500/20 border border-accent-400/30 mb-5">
              <i className="ri-fire-line text-accent-400 text-sm" />
              <span className="text-accent-300 text-xs font-medium">每日更新 · 全网黑料聚合</span>
            </div>

            <h1 className="text-3xl md:text-5xl lg:text-6xl font-black leading-tight mb-4">
              <span className="text-white">91黑料网</span>
              <span className="block text-accent-400 text-xl md:text-2xl lg:text-3xl font-bold mt-2">
                最新黑料视频合集与在线观看平台
              </span>
            </h1>

            <p className="text-white/70 text-sm md:text-base leading-relaxed mb-6 max-w-xl lg:max-w-none">
              91黑料网作为国内领先的黑料视频聚合平台，每日更新最新黑料短视频，覆盖娱乐八卦、社会热点、名人争议等多个领域。
              我们致力于为用户提供一站式的黑料视频在线观看体验，让您不错过任何精彩爆料内容。当前平台已汇集海量黑料视频资源，
              支持流畅在线播放，随时随地掌握最新黑料动态。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              {stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-accent-400 text-lg md:text-xl font-bold">{stat.value}</div>
                  <div className="text-white/50 text-xs mt-0.5">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer no-underline text-sm"
              >
                <i className="ri-play-circle-line text-lg" />
                立即观看黑料视频
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-6 py-3 bg-white/10 hover:bg-white/20 text-white font-medium rounded-lg border border-white/30 transition-colors duration-200 whitespace-nowrap cursor-pointer no-underline text-sm"
              >
                <i className="ri-fire-line text-lg" />
                查看黑料热榜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[360px] md:w-[340px] md:h-[440px] rounded-2xl overflow-hidden border border-white/20">
              <img
                src="https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20poster%20style%20visual%20with%20warm%20amber%20spotlight%20on%20dark%20stage%2C%20abstract%20mysterious%20silhouette%20composition%2C%20entertainment%20industry%20aesthetic%2C%20film%20grain%20texture%2C%20crimson%20and%20gold%20color%20palette%2C%20premium%20editorial%20photography%20style%2C%20dramatic%20shadows%20and%20highlights%2C%20theatrical%20atmosphere%20with%20elegant%20composition%2C%20no%20text%2C%20no%20recognizable%20faces%2C%20artistic%20abstract%20visual&width=680&height=880&seq=hero-visual-91hlw&orientation=portrait"
                alt="91黑料网 - 最新黑料视频合集"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}